import { i18nFilter } from "app/filters/i18nFilter";
import type { FC } from "react";
import { useMemo } from "react";
import type { ICategoryShareServices } from "./CategoryShareTypes";
import CategoryShareTable from "./CategoryShareTable/CategoryShareTable";
import CategoryShareGraph from "./CategoryShareGraph/CategoryShareGraph";
import { swSettings } from "app/common/services/swSettings";
import { allTrackers } from "app/services/track/track";
import { DefaultFetchService } from "app/services/fetchService";
import { apiHelper } from "app/common/services/apiHelper";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import categoryService from "app/common/services/categoryService";
import DurationService from "app/services/DurationService";
import CountryService from "app/services/CountryService";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import type { ISegmentsModule } from "app/services/segments/segmentsApiService";
import { useSelector } from "react-redux";

export const CategoryShare: FC = () => {
    const services: ICategoryShareServices = useMemo(() => {
        return {
            translate: i18nFilter(),
            swNavigator: proNavigator,
            categoryService,
            apiHelper: apiHelper,
            swSettings: swSettings,
            tracker: allTrackers,
            fetchService: DefaultFetchService.getInstance(),
            durationService: DurationService,
            countryService: CountryService,
        };
    }, []);

    const segmentsModule: ISegmentsModule = useSelector((state) => {
        const { segmentsModule } = state;
        return segmentsModule;
    });

    const currentState = services.swNavigator.current().name;
    const tableSelectionKey = `${currentState}_category_share_table`;

    return (
        <FlexColumn>
            <CategoryShareGraph
                services={services}
                tableStateKey={tableSelectionKey}
                segmentsModule={segmentsModule}
            />
            <CategoryShareTable
                services={services}
                tableSelectionKey={tableSelectionKey}
                initialSelectedRowsCount={10}
                maxSelectedRowsCount={10}
                segmentsModule={segmentsModule}
            />
        </FlexColumn>
    );
};
